(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/free-reduction/node.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/free-reduction/node.js'); "use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (svs) {
  var Node = function () {
    function Node(parent, data) {
      _classCallCheck(this, Node);

      this.children = [];
      this.parent = parent;
      this.data = data;
    }

    _createClass(Node, [{
      key: "getRandomWeightedChild",
      value: function getRandomWeightedChild() {
        var sumChildrenWeights = this.children.reduce(function (sumWeight, node) {
          return sumWeight + node.data.weight;
        }, 0);
        var rand = svs.tipset.freeReduction.randomFloatBetween(1, sumChildrenWeights, 10);

        for (var i = 0; i < this.children.length; ++i) {
          if (rand <= this.children[i].data.weight) {
            return this.children[i];
          }

          rand -= this.children[i].data.weight;
        }
      }
    }, {
      key: "getMostNeedyChild",
      value: function getMostNeedyChild(options) {
        var neediestChildren = [],
            currentNeediness;

        for (var i = 0; i < this.children.length; ++i) {
          if (this.children[i].data.weight === 0) {
            continue;
          }

          var neediness = this.children[i].data.weight - this.children[i].data.actual;

          if (currentNeediness === undefined) {
            neediestChildren.push(this.children[i]);
            currentNeediness = neediness;
          } else {
            if (Math.abs(neediness - currentNeediness) <= options.randomizeEqualWeightThreshold) {
              if (neediness > currentNeediness) {
                currentNeediness = neediness;
              }

              neediestChildren.push(this.children[i]);
            } else if (neediness > currentNeediness) {
              neediestChildren = [];
              neediestChildren.push(this.children[i]);
              currentNeediness = neediness;
            }
          }
        }

        if (neediestChildren.length === 1) {
          return neediestChildren[0];
        }

        return neediestChildren[svs.tipset.freeReduction.randIntBetween(0, neediestChildren.length - 1)];
      }
    }, {
      key: "calculateNewActual",
      value: function calculateNewActual() {
        var parentChildren = this.parent.children;
        var totalPicks = 0;

        for (var i = 0; i < parentChildren.length; ++i) {
          totalPicks += parentChildren[i].data.picks;
        }

        for (var _i = 0; _i < parentChildren.length; ++_i) {
          parentChildren[_i].data.updateActual(totalPicks);
        }
      }
    }]);

    return Node;
  }();

  svs.tipset.freeReduction.Node = Node;
})(svs);
 })(window);